import React from 'react'
import { connect } from 'react-redux'
// import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Form, Input } from 'antd'
import { requiredRule } from 'utils/validateRules'
import { intl } from 'utils'
import { refreshCaptcha } from 'store/siteConfig'
class Captcha extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }

  refreshCaptcha = () => {
    this.props.form.resetFields(['captcha'])
    this.props.refreshCaptcha()
  }

  render() {
    const { form, siteConfig } = this.props

    if (!siteConfig.captchaImg) {
      return <></>
    }

    return (
      <Form.Item>
        {form.getFieldDecorator(
          'captcha',
          requiredRule(intl().formatMessage(messages.name))
        )(
          <Input
            size='large'
            maxLength={4}
            suffix={
              <img
                height={22}
                src={siteConfig.captchaImg}
                onClick={this.refreshCaptcha}
              />
            }
            placeholder={intl().formatMessage(messages.name)}
          />
        )}
      </Form.Item>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {
    refreshCaptcha,
  }
)(Form.create()(Captcha))
